module.exports = __webpack_public_path__ + "img/86969-elefant-banner.c6227ae9.png";